import React, { Dispatch, SetStateAction, useState } from 'react';
import callBackendAPI from '../../../utils/callBackendAPI';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import { IoClose } from 'react-icons/io5';
import { signInValidateSchema } from '../../../utils/yupSchemas/ResgistrationSchema';
import Busy from '../../../assets/gif/busy.gif';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../redux/slices/LoginSlice';
import '../../SignUp/form/SignupForm.scss';
import { toast } from 'react-toastify';
import { toastDefaults } from '../../../utils/ToastOptionCommon';
import FormikFormPasswordField from '../../../utils/FormikPasswordField';
import { Base64 } from 'js-base64';
import ForgotPasswordHoc from '../hoc/ForgotPasswordHoc';
import ForgotPasswordForm from './ForgotPasswordForm';
import { trackEvent } from '../../../utils/Analytics';

interface IProps {
  submitHandler: (data: any) => void;
  onModalClosedSignIn: () => void;
  onModalClosedSignUp: () => void;
  initialValues: ISignin;
  isLoading: boolean;
  setLoginError: Dispatch<SetStateAction<string>>;
  loginError: string;
  showForgotPasswordPopup: boolean;
  forgotPasswordToggleHandler: () => void;
}

export interface ISignin {
  Email: string;
  Password: string;
}

const SigninForm = (props: IProps) => {
  const {
    submitHandler,
    onModalClosedSignIn,
    onModalClosedSignUp,
    initialValues,
    isLoading,
    loginError,
    setLoginError,
    forgotPasswordToggleHandler,
    showForgotPasswordPopup,
  } = props;
  const [userEmail, setuserEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isProgress, setIsProgress] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  trackEvent("login_popup_open");

  const handleSubmit = async (values: ISignin) => {
    // e.preventDefault();
    setLoginError(() => '');
    setIsProgress(() => true);
    try {
      const response = await callBackendAPI('POST', 'auth/login', null, {
        userEmail: values.Email,
        password: Base64.encode(values.Password),
      });
      if (response.error) {
        setIsProgress(() => false);
        setLoginError(() => response.error);
      } else {
        setIsProgress(() => false);
        const { token, userData } = response.data;
        userData.isAuthenticated = true;
        localStorage.setItem('accessToken', token);
        localStorage.setItem('user', JSON.stringify(userData));
        // localStorage.setItem('isLoggedin', 'true');
        dispatch(setUserData(response?.data.userData));
        onModalClosedSignIn();
        navigate('/dashboard');
      }
    } catch (error) {
      setIsProgress(() => false);
      // setLoginError(() => 'something went wrong!!!');
      // console.error('Sign in failed:', error);
      toast.error('Invalid email or password', toastDefaults());
      // toast.error(`Sign in failed: ${error}`, toastDefaults());
    }
  };

  const handleSignInRoute = () => {
    onModalClosedSignUp();
    onModalClosedSignIn();
  };

  const handleForgotPasswordPopup = () => {
    forgotPasswordToggleHandler();
    onModalClosedSignIn();
  };

  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <>
      {showForgotPasswordPopup && (
        <ForgotPasswordForm
          submitHandler={handleForgotPasswordPopup}
          onModalClosed={forgotPasswordToggleHandler}
        />
      )}
      {!showForgotPasswordPopup && (
        <Modal className="auth-modal" show={true} centered>
          <Modal.Header>
            <div className="modal-header-content">
              <Modal.Title>Login to your account</Modal.Title>
              <p className="modal-subtitle">
                Enter your credentials to access your account
              </p>
            </div>
            <div
              onClick={onModalClosedSignIn}
              className="icons8-close ms-auto"
              aria-label="Close"
            >
              <IoClose />
            </div>
          </Modal.Header>

          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={signInValidateSchema}
            onSubmit={(values: ISignin) => {
              handleSubmit(values);
            }}
          >
            {({ values }) => (
              <Form noValidate>
                <Modal.Body>
                  {loginError && (
                    <div className="alert alert-danger mb-3">{loginError}</div>
                  )}

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <Field
                      id="email"
                      name="Email"
                      type="email"
                      autoComplete="email"
                      required
                      className="form-control"
                      placeholder="name@example.com"
                    />
                    <ErrorMessage
                      name="Email"
                      component="div"
                      className="invalid-feedback d-block"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <Field
                      id="password"
                      name="Password"
                      type={showPassword ? 'text' : 'password'}
                      autoComplete="current-password"
                      required
                      className="form-control"
                      as={FormikFormPasswordField}
                    />
                    <ErrorMessage
                      name="Password"
                      component="div"
                      className="invalid-feedback d-block"
                    />
                  </div>

                  <Button
                    type="submit"
                    className="btn-primary w-100 py-2 mt-3 mb-2"
                    disabled={isProgress}
                  >
                    {isProgress && (
                      <img
                        src={Busy}
                        alt="Loading..."
                        className="me-2 spinner-gif"
                      />
                    )}
                    Sign In
                  </Button>

                  <div className="text-center mt-3">
                    <p className="mb-1 text-muted small">
                      Not a member yet?{' '}
                      <a onClick={handleSignInRoute} className="fw-semibold">
                        Sign Up
                      </a>
                    </p>
                    <a
                      role="button"
                      onClick={forgotPasswordToggleHandler}
                      className="small fw-semibold d-inline-block mt-1"
                    >
                      Forgot Password?
                    </a>
                  </div>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        </Modal>
      )}
    </>
  );
};

export default ForgotPasswordHoc(SigninForm);
